module.exports = __webpack_public_path__ + "static/img/1.18c8357.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/productBanner/woman/product/1.jpg
// module id = QUG4
// module chunks = 0